import {block} from '../utils/cn';

export const accordionBlock = block('accordion');
export const accordionItemBlock = block('accordion-item');
export const accordionSummaryBlock = block('accordion-summary');

export const accordionSummaryTriggerBlock = accordionSummaryBlock('trigger');
export const accordionDetailsBlock = accordionItemBlock('details');
